import React from 'react';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';


const Therapeutic = ({title=null}) => {
  return (
    <>
        <div className="hidden w-full mx-auto my-4 lg:my-8 lg:block">
            <section className="relative">
                <div className='col-span-12'>
                    {(title) &&
                        <SectionHeading title={title} />
                    }
                </div>
                <div className="grid grid-cols-12 gap-4" style={{marginTop: '12rem'}}>
                    <div className="col-span-12 mx-auto">
                        <div id="Therapeutic">
                            <div className="mt-5 pdelve-feature-circle wow zoomIn postion-relative">
                                <div className="pdelve-img">
                                    <ul className="mb-0 list-inline">
                                        <li className="list-inline-item">
                                            <div className="feature-info">
                                            <div className="feature-img">
                                            <Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/Cell-and-Gene-Therapy.png'} 
                                                alt="image0" 
                                            />
                                            </div>
                                            <h6>Cell and <br/> Gene Therapy</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item ">
                                            <div className="feature-info">
                                            <div className="feature-img">
                                            <Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/Central-Nervous-System.png'} 
                                                alt="image1" 
                                            />
                                            </div>
                                            <h6>Central Nervous <br/> System</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item ">
                                            <div className="feature-info">
                                            <div className="feature-img"><Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/dermatology.png'} 
                                                alt="image2" 
                                            />
                                            </div>
                                            <h6>Dermatology</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item ">
                                            <div className="feature-info">
                                            <div className="feature-img"><Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/Muscuskeletal.png'} 
                                                alt="image3" 
                                            />
                                            </div>
                                            <h6>Musculoskeletal</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item ">
                                            <div className="feature-info">
                                            <div className="feature-img"><Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/Gastroenterology.png'} 
                                                alt="image4" 
                                            />
                                            </div>
                                            <h6>Gastroenterology</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item ">
                                            <div className="feature-info">
                                            <div className="feature-img"><Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/Genetic-Disorder.png'} 
                                                alt="image5" 
                                            />
                                            </div>
                                            <h6>Genetic <br/> Disorder</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item ">
                                            <div className="feature-info">
                                            <div className="feature-img"><Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/hematological-Disorder.png'} 
                                                alt="image6" 
                                            />
                                            </div>
                                            <h6>Hematological <br/> Disorder</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info">
                                            <div className="feature-img"><Image 
                                                priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                className="img-fluid client-img" 
                                                src={process.env.IMG_CDN+'img/primary-research/icons/Infectious-Diseases.png'} 
                                                alt="image7" 
                                            />
                                            </div>
                                            <h6>Infectious <br/> Diseases</h6>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul className="mb-0 list-inline">
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{ top: '0px', left: '-681px', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Oncology.png'} 
                                                        alt="image7"
                                                    />
                                                </div>
                                                <h6>Oncology</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '24%' , left: '-37%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Rare-Diseases.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Rare Diseases</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '-19%', right: '-9%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Otolaryngology.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Otolaryngology</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '5%' , right: '-26%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Neurology.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Neurology</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{ top: '92%', zIndex: '9',left: '104%'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Respiratory-Diseases.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Respiratory <br/>Diseases</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '67%', left: '117%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Endocrinalogy-and-Metabolic-Disorder.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Endocrinology and<br/>Metabolic Disorder</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '36%', right: '-37%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Dental-and-Oral-Health.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Dental and <br/>Oral Health</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '-34%',right: '-7%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Cardiovascular-Diseases.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Cardiovascular <br/> Diseases</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '-37%', left: '40%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Male-Health.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Male <br/> Health</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '-27%', left: '0%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Non-malignant-disorders.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Non-malignant <br/>Disorders</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '123%', left: '43%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Immunological-and-autoimmune-disorders.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Immunological and <br/>autoimmune disorders</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '112%' , left: '83%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Pediatrics.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Pediatrics</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '50%', left: '-40%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Sleep-disorders.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Sleep disorders</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '79%', left: '-28%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Toxicology.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Toxicology</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '105%', left: '-10%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Womens-health.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Women&apos;s Health</h6>
                                            </div>
                                        </li>
                                        <li className="list-inline-item">
                                            <div className="feature-info" style={{top: '120%', left: '11%', zIndex: '9'}}>
                                                <div className="feature-img">
                                                    <Image 
                                                        priority={false} 
                                                        width={2000} 
                                                        height={2000} 
                                                        className="img-fluid client-img" 
                                                        src={process.env.IMG_CDN+'img/primary-research/icons/Nutritional-disorder--and-weight-loss.png'} 
                                                        alt="image7" 
                                                    />
                                                </div>
                                                <h6>Nutritional disorders <br/>and weight loss</h6>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="dot-circle">
                                        <div className="effect-circle"></div>
                                    </div>
                                    <div className="main-circle">
                                        <div className="circle-bg">
                                            <Image
                                                priority={false}
                                                className="w-20"
                                                width={2000}
                                                height={2000}
                                                src={process.env.IMG_CDN+'img/primary-research/icons/6-9.png'}
                                                alt='DelveInsight'
                                                style={{ left: '30px', position: 'relative' , top: '25px'}}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </>
  )
}
export default Therapeutic;
